import { render } from "./FullFroala.vue?vue&type=template&id=397dfb95"
import script from "./FullFroala.vue?vue&type=script&lang=js"
export * from "./FullFroala.vue?vue&type=script&lang=js"

import "./FullFroala.vue?vue&type=style&index=0&id=397dfb95&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__